import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export var OutlinedButton = function OutlinedButton(param) {
    var onClick = param.onClick, _param_label = param.label, label = _param_label === void 0 ? 'Click' : _param_label;
    return /*#__PURE__*/ _jsx("button", {
        className: "border border-gray-800 text-white rounded-full px-3 py-2 font-semibold text-sm leading-[1.5] min-w-[80px] h-[2.6rem] cursor-pointer transition-all duration-200 ease-in-out hover:bg-white hover:text-[rgb(9,8,7)] hover:border-gray-800",
        onClick: onClick,
        children: label
    });
};
